import { mapGetters } from "vuex";

export default {
	name: "MoreButton",
	props: ["url", "portfolio"],
	computed: {
		...mapGetters("staticContent", ["getTranslations"]),
		
		urlWithUtm() {
			if (!this.url) return "";
			
			const url = new URL(this.url);
			url.searchParams.set("utm_source", "diversey-gps");
			return url.toString();
		},
	},
	methods: {
		handleClick() {
			if (window.gtag) {
				window.gtag("event", "more_information_click", {
					event_category: "external_link",
					event_label: this.url,
					portfolio: this.portfolio,
					destination_url: this.urlWithUtm,
				});
			}
			
			if (window.dataLayer) {
				window.dataLayer.push({
					event: "more_information_click",
					click_text: "more information",
					destination_url: this.urlWithUtm,
					portfolio: this.portfolio,
					utm_source: "diversey-gps",
				});
			}
		},
	},
};
